// Generated from the original Kaya PWA icon set by scripts/extract-data.js style extraction.
import type { ReactElement } from "react";

export type IconName =
  | "core"
  | "upper"
  | "cardio"
  | "mobility"
  | "check"
  | "plus"
  | "flag"
  | "plane"
  | "play"
  | "pause"
  | "skip"
  | "scale"
  | "tape"
  | "target"
  | "fire"
  | "ext"
  | "dl"
  | "bell"
  | "walk"
  | "sun"
  | "dumbbell"
  | "bowl"
  | "progress"
  | "user"
  | "chevron-left"
  | "chevron-right"
  | "chevron-down"
  | "close"
  | "more"
  | "refresh"
  | "minus"
  | "treadmill"
  | "drop"
  | "snowflake"
  | "bandage"
  | "medal"
  | "footsteps"
  | "flame"
  | "clock"
  | "calendar"
  | "info"
  | "phone"
  | "cloud-sync"
  | "lock"
  | "edit"
  | "trash"
  | "book"
  | "list"
  | "tick"
  | "glass"
  | "bottle"
  | "undo"
  | "search"
  | "legs"
  | "balance"
  | "breath";

type V1Name =
  | "core" | "upper" | "cardio" | "mobility" | "check" | "plus" | "flag" | "plane" | "play" | "pause"
  | "skip" | "scale" | "tape" | "target" | "fire" | "ext" | "dl" | "bell" | "walk";

/** The original inline SVG set. Each icon inherits colour from its container. */
const V1: Record<V1Name, ReactElement> = {
  core: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="8"/><path d="M8 12h8M12 8v8"/></svg>
  ),
  upper: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 8v8M18 8v8M3 10v4M21 10v4M6 12h12"/></svg>
  ),
  cardio: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.8 8.6c0 5-8.8 11-8.8 11S3.2 13.6 3.2 8.6a4.4 4.4 0 0 1 8.8-.9 4.4 4.4 0 0 1 8.8.9z"/><path d="M3 12h4l2-3 3 6 2-4h7"/></svg>
  ),
  mobility: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 15c3-6 6-6 9 0s6 6 9 0"/><path d="M3 9c3-6 6-6 9 0s6 6 9 0" opacity=".45"/></svg>
  ),
  plus: (
    <svg className="i" viewBox="0 0 24 24">
      <path d="M12 5v14M5 12h14" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12l4.5 4.5L19 7"/></svg>
  ),
  flag: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 21V4a1 1 0 0 1 1-1h11l-2 4 2 4H6"/></svg>
  ),
  plane: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12l8 2 3 7 2-2-1-6 6-3 1-3-3 1-6 6-6-1-2 2z"/></svg>
  ),
  play: (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 5v14l12-7z"/></svg>
  ),
  pause: (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>
  ),
  skip: (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M5 5l10 7-10 7zM17 5h2v14h-2z"/></svg>
  ),
  scale: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="4"/><path d="M8 10a5 5 0 0 1 8 0M12 12l2-2"/></svg>
  ),
  tape: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="12" r="5"/><path d="M13 12h8M17 12v3M21 12v3M15 12v2"/></svg>
  ),
  target: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1"/></svg>
  ),
  fire: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22c4 0 7-3 7-7 0-4-3-6-4-9-1 2-2 3-3 3 0-3-1-5-3-7-1 3-5 6-5 12a7 7 0 0 0 8 8z"/></svg>
  ),
  ext: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/></svg>
  ),
  dl: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12M6 11l6 6 6-6M4 21h16"/></svg>
  ),
  bell: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 16V11a6 6 0 0 1 12 0v5l2 2H4zM10 21h4"/></svg>
  ),
  walk: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="13" cy="4" r="1.6"/><path d="M8 21l3-7 2 2v5M14 9l-2-1-3 2-2 4M12 8l2 4 3 1"/></svg>
  ),
};


/**
 * The v2 kit's icons (SNIPPETS.md §21): 24 grid, stroke 1.8, round caps and joins, currentColor.
 * Paths copied from the kit. `more` is filled on purpose, like play/pause/skip above.
 */
function k(children: ReactElement | ReactElement[]): ReactElement {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {children}
    </svg>
  );
}

const V2: Record<Exclude<IconName, V1Name>, ReactElement> = {
  sun: k(<><circle cx="12" cy="12" r="4"/><path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4"/></>),
  dumbbell: k(<path d="M6 7v10M18 7v10M3 10v4M21 10v4M6 12h12"/>),
  bowl: k(<><path d="M3 11h18"/><path d="M3 11a9 9 0 0 0 18 0"/><path d="M9 7.5c0-1.2 1.2-1.6 1.2-3M13.8 7.5c0-1.2 1.2-1.6 1.2-3"/></>),
  progress: k(<><path d="M4 4v16h16"/><path d="M8 15l3.5-3.5 3 3L20 9"/></>),
  user: k(<><circle cx="12" cy="8" r="4"/><path d="M4.5 20.5a7.5 7.5 0 0 1 15 0"/></>),
  "chevron-left": k(<path d="M15 18l-6-6 6-6"/>),
  "chevron-right": k(<path d="M9 6l6 6-6 6"/>),
  "chevron-down": k(<path d="M6 9l6 6 6-6"/>),
  close: k(<path d="M6 6l12 12M18 6L6 18"/>),
  more: k(<><circle cx="5" cy="12" r="1.6" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none"/><circle cx="19" cy="12" r="1.6" fill="currentColor" stroke="none"/></>),
  refresh: k(<><path d="M4 4v5h5"/><path d="M20 20v-5h-5"/><path d="M5.2 9A7.5 7.5 0 0 1 19 8.5"/><path d="M18.8 15A7.5 7.5 0 0 1 5 15.5"/></>),
  minus: k(<path d="M5 12h14"/>),
  treadmill: k(<><rect x="2" y="15" width="16" height="4" rx="2"/><path d="M15.5 15l3-10H21"/><path d="M17 8.5h4"/></>),
  drop: k(<path d="M12 3s6 6.4 6 11a6 6 0 0 1-12 0c0-4.6 6-11 6-11z"/>),
  snowflake: k(<><path d="M12 2v20M3.3 7l17.4 10M3.3 17l17.4-10"/><path d="M9 4l3 2 3-2M9 20l3-2 3 2"/></>),
  bandage: k(<><rect x="2.5" y="8.5" width="19" height="7" rx="3.5" transform="rotate(-45 12 12)"/><path d="M10.6 10.6h.01M13.4 13.4h.01M13.4 10.6h.01M10.6 13.4h.01"/></>),
  medal: k(<><circle cx="12" cy="15" r="5"/><path d="M8.5 11.4L6 3h4l2 4.5L14 3h4l-2.5 8.4"/></>),
  footsteps: k(<><path d="M8 3C6 3 5 5.5 5 8s1 4 3 4 2.5-1.8 2.5-4.3S10 3 8 3z"/><path d="M5.5 15h5v1.2a2.5 2.5 0 0 1-5 0z"/><path d="M16 7c2 0 3 2.5 3 5s-1 4-3 4-2.5-1.8-2.5-4.3S14 7 16 7z"/><path d="M13.5 19h5v.2a2.5 2.5 0 0 1-5 0z"/></>),
  flame: k(<path d="M12 22c4 0 7-3 7-7 0-4-3-6-4-9-1 2-2 3-3 3 0-3-1-5-3-7-1 3-5 6-5 12a7 7 0 0 0 8 8z"/>),
  clock: k(<><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>),
  calendar: k(<><rect x="3" y="5" width="18" height="16" rx="3"/><path d="M3 10h18M8 3v4M16 3v4"/></>),
  info: k(<><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></>),
  phone: k(<><rect x="7" y="2.5" width="10" height="19" rx="2.5"/><path d="M11 18h2"/></>),
  "cloud-sync": k(<><path d="M7 18.5a4 4 0 0 1-.7-7.9A6 6 0 0 1 17.9 11a3.75 3.75 0 0 1-.4 7.5z"/><path d="M9.5 14l2 2 3.5-3.5"/></>),
  lock: k(<><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></>),
  edit: k(<><path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M13 7l4 4"/></>),
  trash: k(<path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/>),
  book: k(<><path d="M5 5a2 2 0 0 1 2-2h12v15H7a2 2 0 0 0-2 2z"/><path d="M5 20a2 2 0 0 0 2 1h12v-3"/></>),
  list: k(<path d="M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01"/>),
  /** the kit's check at the kit's stroke; the old `check` is drawn at 3 for the players */
  tick: k(<path d="M5 12l4.5 4.5L19 7"/>),
  /* water (kit §37) */
  glass: k(<><path d="M5 3h14l-1.6 16.2a2 2 0 0 1-2 1.8H8.6a2 2 0 0 1-2-1.8z"/><path d="M5.8 10h12.4"/></>),
  bottle: k(<><path d="M10 2h4v3.2l2.2 3a2 2 0 0 1 .3 1V20a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2V9.2a2 2 0 0 1 .3-1L10 5.2z"/><path d="M7.5 13h9"/></>),
  undo: k(<><path d="M9 14L4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/></>),
  search: k(<><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></>),
  /* the move library's three kinds (ADR-051): a bent leg, a one-leg stance, a breath */
  legs: k(<><path d="M9 3l4.5 8L10 19"/><path d="M10 19h5.5"/></>),
  balance: k(<><circle cx="12" cy="4.5" r="2"/><path d="M12 8v6M6 10.5h12M12 14l-1.5 7M12 14l4 2.5"/></>),
  breath: k(<><path d="M3 9h10.5a2.5 2.5 0 1 0-2.5-2.5"/><path d="M3 15h14.5a2.5 2.5 0 1 1-2.5 2.5"/><path d="M3 12h7"/></>),
};

/** Every icon, old and v2, by name. */
export const I: Record<IconName, ReactElement> = { ...V1, ...V2 };

export function Icon({ name, className }: { name: IconName; className?: string }) {
  const el = I[name];
  return className ? <span className={className}>{el}</span> : el;
}

/** Which icon stands for each session type. */
export const SESSION_ICON: Record<
  "A" | "B" | "C" | "T" | "P" | "Y" | "R" | "SB" | "GC" | "CH" | "MJ" | "WK" | "YB",
  IconName
> = {
  A: "core",
  B: "cardio",
  C: "mobility",
  T: "plane",
  R: "mobility",
  P: "mobility",
  Y: "mobility",
  SB: "balance",
  GC: "cardio",
  CH: "legs",
  MJ: "mobility",
  WK: "walk",
  YB: "sun",
};
